export default "__VITE_ASSET__BNBYpaki__"